import React from 'react';

const HistoryTab = ({ filterHistory, getRecommendations }) => (
  <div data-testid="cp-hist-panel">
    <div className="shimmer-text" style={{ fontSize: '0.52rem', marginBottom: 6, fontWeight: 600 }}>FILTER HISTORY, ANALYTICS & RECOMMENDATIONS</div>
    
    {filterHistory && filterHistory.length > 0 && (() => {
      const actionCounts = {};
      (filterHistory || []).forEach(h => { actionCounts[h.action] = (actionCounts[h.action] || 0) + 1; });
      const sorted = Object.entries(actionCounts).sort((a, b) => b[1] - a[1]).slice(0, 6);
      const maxCount = sorted.length > 0 ? sorted[0][1] : 1;
      return (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: '0.46rem', color: '#38bdf8', marginBottom: 4, fontWeight: 600 }}>MOST CHANGED FILTERS</div>
          {sorted.map(([action, count]) => (
            <div key={action} style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 2 }}>
              <span style={{ color: '#71717a', fontSize: '0.44rem', width: 70, textAlign: 'right', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{action.replace('toggle_', '').replace('set_', '')}</span>
              <div style={{ flex: 1, height: 6, background: 'rgba(253, 230, 138,0.08)', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{ width: `${(count / maxCount) * 100}%`, height: '100%', background: 'linear-gradient(90deg, #38bdf8, #FDE047)', borderRadius: 3, transition: 'width 0.3s' }} />
              </div>
              <span style={{ color: '#38bdf8', fontSize: '0.44rem', width: 16, textAlign: 'right' }}>{count}</span>
            </div>
          ))}
        </div>
      );
    })()}

    {filterHistory && filterHistory.length >= 5 && (() => {
      const recent5 = filterHistory.slice(0, 5);
      const allSameAction = recent5.every(h => h.action === recent5[0].action);
      if (allSameAction) {
        return (
          <div style={{ padding: '3px 6px', background: 'rgba(251,191,36,0.08)', borderRadius: 4, marginBottom: 6, fontSize: '0.48rem', color: '#047857', border: '1px solid rgba(251,191,36,0.15)' }}>
            <i className="fas fa-exclamation-triangle" style={{ marginRight: 3, fontSize: '0.42rem' }} />
            Pattern: You've toggled "{recent5[0].action}" {recent5.length}x in a row. Consider saving a preset.
          </div>
        );
      }
      return null;
    })()}
    
    {getRecommendations && (() => {
      const recs = getRecommendations();
      if (recs.length === 0) return <div style={{ color: '#333', fontSize: '0.5rem', marginBottom: 8 }}>No recommendations yet. Use filters to build history.</div>;
      return (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: '0.48rem', color: '#10b981', marginBottom: 3, fontWeight: 600 }}>SUGGESTIONS</div>
          {recs.map((r, i) => (
            <div key={i} style={{ padding: '3px 6px', background: 'rgba(16,185,129,0.08)', borderRadius: 4, marginBottom: 3, fontSize: '0.5rem', color: '#a1a1aa', border: '1px solid rgba(16,185,129,0.1)' }}>
              <i className="fas fa-lightbulb" style={{ color: '#10b981', marginRight: 4, fontSize: '0.45rem' }} />
              {r.label}
            </div>
          ))}
        </div>
      );
    })()}

    <div style={{ fontSize: '0.48rem', color: '#555', marginBottom: 3, fontWeight: 600 }}>RECENT CHANGES ({(filterHistory || []).length} entries)</div>
    <div style={{ maxHeight: 200, overflowY: 'auto' }}>
      {(filterHistory || []).slice(0, 30).map((h, i) => (
        <div key={i} style={{ padding: '2px 4px', borderBottom: '1px solid rgba(253, 230, 138,0.04)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#71717a', fontSize: '0.48rem' }}>
            <span style={{ color: '#38bdf8' }}>{h.action}</span>
            {h.detail && <span style={{ color: '#555' }}> &middot; {h.detail.slice(0, 30)}</span>}
          </span>
          <span style={{ color: '#333', fontSize: '0.42rem' }}>{new Date(h.timestamp).toLocaleTimeString()}</span>
        </div>
      ))}
      {(!filterHistory || filterHistory.length === 0) && <span style={{ color: '#333', fontSize: '0.48rem' }}>No history yet</span>}
    </div>
  </div>
);

export default HistoryTab;
